import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  role: 'manager' | 'waiter' | 'kitchen';
  name?: string;
}

interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  token: string | null;
  login: (role: 'manager' | 'waiter' | 'kitchen', pin: string) => Promise<boolean>;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      user: null,
      token: null,

      login: async (role: 'manager' | 'waiter' | 'kitchen', pin: string) => {
        try {
          const response = await fetch(`/api/v1/auth/${role}/login`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ pin }),
          });

          if (!response.ok) {
            const error = await response.json();
            console.error('Login failed:', error);
            return false;
          }

          const data = await response.json();
          
          if (data.success) {
            set({
              isAuthenticated: true,
              user: {
                id: data.user.id,
                role: data.user.role,
                name: data.user.name,
              },
              token: data.token,
            });
            return true;
          }

          return false;
        } catch (error) {
          console.error('Login error:', error);
          return false;
        }
      },

      logout: () => {
        set({
          isAuthenticated: false,
          user: null,
          token: null,
        });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        user: state.user,
        token: state.token,
      }),
    }
  )
);
